import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import AppHeader from "@/components/AppHeader";
import SignupFields, { emptySignupForm } from "@/components/SignupFields";
import { toast } from "sonner";
import { ArrowRight } from "lucide-react";

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState(emptySignupForm());
  const [submitting, setSubmitting] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    const res = await register(form);
    setSubmitting(false);
    if (res.ok) {
      toast.success("Account created.");
      navigate("/dashboard");
    } else {
      toast.error(res.error);
    }
  };

  return (
    <div className="min-h-screen bg-[#030303] text-white">
      <AppHeader />
      <main className="max-w-md mx-auto px-6 py-16">
        <p className="text-xs font-mono uppercase tracking-widest text-[#FFD700] mb-3">
          / New Case
        </p>
        <h1 className="font-display text-5xl font-black tracking-tighter mb-2">
          Sign up.
        </h1>
        <p className="text-white/50 mb-8">
          Open a secure client file with Crypto Asset Recovery.
        </p>

        <form onSubmit={onSubmit} className="space-y-4">
          <SignupFields form={form} setForm={setForm} prefix="register" stacked />
          <button
            type="submit"
            disabled={submitting}
            data-testid="register-submit-btn"
            className="w-full bg-[#FFD700] hover:bg-[#F4C430] disabled:opacity-50 text-black font-semibold py-3 flex items-center justify-center gap-2 transition-colors"
          >
            {submitting ? "Creating..." : "Create Account"}
            <ArrowRight className="w-4 h-4" />
          </button>
        </form>

        <p className="text-sm text-white/50 mt-8 text-center">
          Already a client?{" "}
          <Link
            to="/login"
            data-testid="register-login-link"
            className="text-[#FFD700] hover:underline"
          >
            Log in
          </Link>
        </p>
      </main>
    </div>
  );
}
